import { render, staticRenderFns } from "./OtherDocuments.vue?vue&type=template&id=6fdf6679"
import script from "./OtherDocuments.vue?vue&type=script&lang=js"
export * from "./OtherDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports